export const APP_BASENAME = '/b';

type PageTitleRule = {
  prefixes: readonly string[];
  title: string;
  geolocation?: 'client' | 'manual';
};

const routeMetadata: readonly PageTitleRule[] = [
  { prefixes: ['/section'], title: 'Выбор магазина' },
  {
    prefixes: ['/shifts', '/scanner', '/photo', '/maps'],
    title: 'Мои смены',
    geolocation: 'client',
  },
  { prefixes: ['/history'], title: 'Мои смены' },
  { prefixes: ['/manual'], title: 'Ручная регистрация', geolocation: 'manual' },
  { prefixes: ['/outsourcing'], title: 'ИСИТ' },
  { prefixes: ['/employees'], title: 'Мои сотрудники' },
  { prefixes: ['/store'], title: '' },
];

const matchesPathPrefix = (pathname: string, prefix: string) =>
  pathname === prefix || pathname.startsWith(`${prefix}/`);

export const getRouteMetadata = (pathname: string) =>
  routeMetadata.find(({ prefixes }) =>
    prefixes.some((prefix) => matchesPathPrefix(pathname, prefix)),
  );

export const getPageTitle = (pathname: string, isClientHome = false) => {
  if (pathname === '/' && isClientHome) return 'Мои смены';

  return getRouteMetadata(pathname)?.title ?? 'Мои сотрудники';
};

export const withAppBasename = (path = '/') => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${APP_BASENAME}${normalizedPath}`;
};

export const getAppAbsoluteUrl = (path = '/') =>
  `${typeof window !== 'undefined' ? window.location.origin : ''}${withAppBasename(path)}`;

export const normalizeAppBasePath = () => {
  if (typeof window === 'undefined' || window.location.pathname !== APP_BASENAME) return;

  window.history.replaceState(
    window.history.state,
    '',
    `${APP_BASENAME}/${window.location.search}${window.location.hash}`,
  );
};
